import React, { forwardRef, useState } from 'react';

import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';
import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { SourceGroupedCheckbox } from '@vlabs/shared/components/filters-panel/common/source-select-popover/components/SourceGroupedCheckbox';

import { useWorkspaceFilters } from '../../useWorkspaceFilters';

function SourcesFilterPopover(
  props: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
): React.JSX.Element {
  const { filters, updateFilters } = useWorkspaceFilters();
  const [createdSources, setCreatedSources] = useState<string[]>([]);
  const selectedSources = filters?.sources ?? [];

  return (
    <PopoverWithButton
      {...props}
      isButtonDisabled={selectedSources.length === 0}
      ref={ref}
    >
      <SourceGroupedCheckbox
        customSourceNames={createdSources}
        onChangeCustomSourceNames={setCreatedSources}
        onChangeSelectedSource={(sources) => updateFilters({
          sources: sources.length > 0 ? sources : undefined,
        })}
        selectedSources={selectedSources}
      />
    </PopoverWithButton>
  );
}

const SourcesFilterPopoverWithRef = forwardRef(SourcesFilterPopover);
export { SourcesFilterPopoverWithRef as SourcesFilterPopover };
